import { render } from "./AppSettings.vue?vue&type=template&id=5c47375a&scoped=true"
const script = {}

import "./AppSettings.vue?vue&type=style&index=0&id=5c47375a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c47375a"]])

export default __exports__